import { render, staticRenderFns } from "./RoomType.vue?vue&type=template&id=2aa5aecf&"
import script from "./RoomType.vue?vue&type=script&lang=js&"
export * from "./RoomType.vue?vue&type=script&lang=js&"
import style0 from "./RoomType.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports